import { Group as MantineGroup } from '@mantine/core'
import { GroupProps } from './group.types'

export const Group = ({ ...props }: GroupProps) => <MantineGroup {...props} />
